export interface RailNavItemDef {
  id: string;
  label: string;
  labelKey: string; // i18n key in the menuBar namespace
  path: string;
  icon: string; // SVG path data for 24x24 viewBox
  resource?: string;
  requiredPermission?: string;
  section?: string; // undefined = top section, "Configuration" = config section
  featureFlag?: string;
}

export const NAV_ITEMS: RailNavItemDef[] = [
  // -- Top section (no label) -----------------------------------------------
  {
    id: "dashboard",
    label: "Dashboard",
    labelKey: "dashboard",
    path: "dashboard",
    icon: "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z",
    resource: "interactions",
    requiredPermission: "Read",
  },
  {
    id: "search",
    label: "Search",
    labelKey: "search",
    path: "search",
    icon: "M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z",
    resource: "interactions",
    requiredPermission: "Read",
  },
  {
    id: "views",
    label: "Views",
    labelKey: "views",
    path: "views",
    icon: "M3 6h18M3 12h18M3 18h18",
    resource: "views",
    requiredPermission: "*",
  },
  {
    id: "exports",
    label: "Exports",
    labelKey: "exports",
    path: "jobs/bulk-export",
    icon: "M12 2v13M7 10l5 5 5-5M20 17v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2",
    resource: "interactions",
    requiredPermission: "Export",
  },

  // -- Configuration section ------------------------------------------------
  {
    id: "users",
    label: "Users",
    labelKey: "users",
    path: "users",
    icon: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
    resource: "users",
    requiredPermission: "Read",
    section: "Configuration",
  },
  {
    id: "sites",
    label: "Sites",
    labelKey: "sites",
    path: "sites",
    icon: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z",
    resource: "sites",
    requiredPermission: "Read",
    section: "Configuration",
  },
  {
    id: "roles",
    label: "Roles",
    labelKey: "roles",
    path: "roles",
    icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
    resource: "roles",
    requiredPermission: "Read",
    section: "Configuration",
  },
  {
    id: "summary-templates",
    label: "Summary Templates",
    labelKey: "summaryTemplates",
    path: "summary-templates",
    icon: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5zM4 9h16M4 14h16M9 4v16",
    resource: "summary-templates",
    requiredPermission: "Read",
    section: "Configuration",
    featureFlag: "Summarization",
  },
  {
    id: "connectors",
    label: "Connectors",
    labelKey: "connectors",
    path: "connectors",
    icon: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71",
    resource: "connectors",
    requiredPermission: "Read",
    section: "Configuration",
  },
  {
    id: "audit-logs",
    label: "Audit Logs",
    labelKey: "auditLogs",
    path: "audit-logs",
    icon: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8",
    resource: "auditlogs",
    requiredPermission: "Read",
    section: "Configuration",
  },
  {
    id: "header-names",
    label: "Table Headers",
    labelKey: "tableHeaders",
    path: "header-names",
    // Settings/table icon: grid with a gear
    icon: "M3 3h7v4H3zM14 3h7v4h-7zM3 10h7v4H3zM14 10h7v4h-7zM3 17h7v4H3zM14 17h7v4h-7z",
    section: "Configuration",
  },
];
